<tbs-dialog tbsSeparator="top-bottom">
  <tbs-dialog-header tbsHeading="My Profile" />
  <mat-dialog-content>
    <tbs-tabs tbsSize="default">
      <mat-tab-group animationDuration="0ms" mat-align-tabs="start" [mat-stretch-tabs]="false">
        <mat-tab label="General">
          <core-user-form [data]="user()" [submitForm]="submit()" (formChanged)="valueChanged($event)" />
        </mat-tab>
        <mat-tab label="Security">
          <div class="security-wrapper">
            <div class="flex-rbc mb-3">
              <span class="email tb-body-primary">{{ user().email }}</span>
              <button
                tbs-button
                tbsType="ghost"
                [tbsLoading]="resetPasswordStatus() === 'loading'"
                (click)="resetPassword()"
              >
                Reset Password
              </button>
            </div>
            @if (resetPasswordStatus() === 'success') {
              <tbs-callout tbsType="success">
                An email has been sent to your address with instructions on how to change your password.
              </tbs-callout>
            }

            @if (resetPasswordStatus() === 'error') {
              <tbs-callout tbsType="error">
                There was an error while sending the email for resetting the password. Please try again.
              </tbs-callout>
            }
          </div>
        </mat-tab>
      </mat-tab-group>
    </tbs-tabs>
  </mat-dialog-content>

  <div mat-dialog-actions align="end" class="flex-gap-10 actions">
    <button tbs-button tbsType="ghost" mat-dialog-close>Close</button>
    <button tbs-button [disabled]="!formDirty()" (click)="submitDialog()">Save</button>
  </div>
</tbs-dialog>
